// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const dimensionInDescriptionMax = 300;

export const dimensionInKeyOneMax = 40;

export const dimensionInLabelMax = 40;

export const dimensionInWeightMin = 0;
export const dimensionInWeightMax = 100;

export const DimensionIn = zod.object({
  "axis": zod.union([zod.enum(['impact', 'feasibility']),zod.null()]).optional(),
  "description": zod.string().min(1).max(dimensionInDescriptionMax),
  "key": zod.union([zod.string().max(dimensionInKeyOneMax),zod.null()]).optional(),
  "label": zod.string().min(1).max(dimensionInLabelMax),
  "weight": zod.int().min(dimensionInWeightMin).max(dimensionInWeightMax)
});

export type DimensionIn = zod.input<typeof DimensionIn>;
export type DimensionInOutput = zod.output<typeof DimensionIn>;
